import { render, staticRenderFns } from "./BrandActionsTooltip.vue?vue&type=template&id=385e7d21"
import script from "./BrandActionsTooltip.vue?vue&type=script&lang=js"
export * from "./BrandActionsTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports